const DATA_TYPE = {
  text: 1, // 输入文字类型
  select: 3, // 选择类型
  amount: 4, // 金额类型
  switch: 5, // 开关类型
  time: 6, // 时间类型
  ext: 99, // 其它类型（比如：助教的课程收费中的最低消费，需要其它数值计算出来的）
}

module.exports = {
  DATA_TYPE: DATA_TYPE,

  // 模板名称
  templateInfo: () => [
    {
      required: true,
      key: 'name',
      title: '模板名称',
      toastTip: '请输入模板名称',
      type: 'text',
      id: -1,
      value: '',
      suffix: '',
      disabled: false,
      dataType: DATA_TYPE.text,
    },
  ],

  // 基本信息
  basicInfo: () => [
    {
      required: true,
      key: 'name',
      title: '姓名',
      toastTip: '请输入姓名',
      type: 'text',
      value: '',
      suffix: '',
      disabled: false,
      dataType: DATA_TYPE.text,
    },
    {
      required: true,
      key: 'jobTitle',
      title: '职位',
      toastTip: '请输入职位',
      type: 'text',
      value: '',
      suffix: '',
      disabled: false,
      dataType: DATA_TYPE.text,
    },
    {
      required: true,
      key: 'phone',
      title: '手机号码',
      toastTip: '请输入手机号码',
      type: 'number',
      value: '',
      suffix: '',
      disabled: false,
      dataType: DATA_TYPE.text,
    },
    {
      required: false,
      key: 'account',
      title: '收银端账号',
      toastTip: '请输入收银端账号',
      type: 'text',
      value: '',
      suffix: '',
      disabled: false,
      dataType: DATA_TYPE.text,
    },
    {
      required: false,
      key: 'password',
      title: '密码',
      toastTip: '请输入密码',
      type: 'password',
      value: '',
      suffix: '',
      disabled: false,
      dataType: DATA_TYPE.text,
    },
  ],

  // 基础薪酬
  basicsSalary: () => [
    {
      required: false,
      key: 'salaryType',
      title: '基础薪酬',
      disabled: false,
      value: 0,
      options: [],
      dataType: DATA_TYPE.select,
    },
  ],

  // 月薪
  monthlySalary: () => [
    {
      required: false,
      key: 'amount',
      title: '月薪',
      toastTip: '请输入月薪',
      type: 'number',
      value: '',
      suffix: '元',
      disabled: false,
      dataType: DATA_TYPE.amount,
    },
  ],

  // 考勤班次
  attendanceShift: () => [
    {
      required: false,
      key: 'id',
      title: '考勤班次',
      toastTip: '请选择考勤班次',
      disabled: false,
      value: -1,
      options: [],
      dataType: DATA_TYPE.select,
    },
  ],

  // 假期和奖励
  salaryInfo: () => [
    {
      required: false,
      key: 'monthHoliday',
      title: '每月假期',
      toastTip: '请输入每月假期',
      type: 'number',
      value: '',
      suffix: '天',
      disabled: false,
      dataType: DATA_TYPE.text,
    },
    {
      required: false,
      key: 'attendanceBonus',
      title: '全勤奖励',
      toastTip: '请输入全勤奖励',
      type: 'number',
      value: '',
      suffix: '元',
      disabled: false,
      dataType: DATA_TYPE.amount,
    },
  ],

  // 商品销售提成
  commoditySales: () => [
    // {
    //   required: false,
    //   key: 'isSellingCommissionEnabled',
    //   title: '商品销售提成',
    //   toolTip: '拥有商品销售提成权限',
    //   value: false,
    //   disabled: false,
    //   special: false,
    //   dataType: DATA_TYPE.switch,
    // },
  ],

  // 模板
  templateSelect: () => [
    {
      required: false,
      key: 'templateSelect',
      title: '模板',
      disabled: false,
      value: 0,
      options: [],
      dataType: DATA_TYPE.select,
    },
  ],

  // 权限设置
  authInfo: () => [
    {
      required: false,
      key: 'attendanceClock',
      title: '考勤打卡',
      toolTip: '拥有考勤打卡权限',
      value: false,
      disabled: false,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    {
      required: false,
      key: 'mobileDispensers',
      title: '移动掌柜',
      toolTip: '拥有移动掌柜操作权限',
      value: false,
      disabled: false,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    // {
    //   required: false,
    //   key: 'entryWithdraw',
    //   title: '资金提现',
    //   toolTip: '拥有资金提现权限',
    //   value: false,
    //   disabled: false,
    //   special: false,
    //   dataType: DATA_TYPE.switch,
    // },
    {
      required: false,
      key: 'attendanceManagement',
      title: '考勤管理',
      toolTip: '拥有考勤管理权限',
      value: false,
      disabled: false,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    {
      required: false,
      key: 'employeeManagement',
      title: '员工管理',
      toolTip: '拥有员工管理权限',
      value: false,
      disabled: false,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    // {
    //   required: false,
    //   key: 'managementBackground',
    //   title: '管理后台',
    //   toolTip: '拥有管理后台操作权限',
    //   value: false,
    //   disabled: false,
    //   special: false,
    //   dataType: DATA_TYPE.switch,
    // },
    {
      required: false,
      key: 'purchaseSalesInventory',
      title: '进销存',
      toolTip: '拥有进销存操作权限',
      value: false,
      disabled: false,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    {
      required: false,
      key: 'tableClothManager',
      title: '台布管理',
      toolTip: '拥有设置使用台布权限',
      value: false,
      disabled: false,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    {
      required: false,
      key: 'cancelStocks',
      title: '退库权限',
      toolTip: '拥有退库操作权限',
      value: false,
      disabled: false,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    {
      required: false,
      key: 'checkMemberManage',
      title: '查看会员管理',
      toolTip: '拥有会员管理查看权限',
      value: false,
      disabled: false,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    {
      required: false,
      key: 'editMemberManage',
      title: '编辑会员管理',
      toolTip: '拥有会员管理操作权限',
      value: false,
      disabled: false,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    // {
    //   required: false,
    //   key: 'memberGrade',
    //   title: '会员等级',
    //   toolTip: '拥有会员等级操作权限',
    //   value: false,
    //   disabled: false,
    //   special: false,
    //   dataType: DATA_TYPE.switch,
    // },
    {
      required: false,
      key: 'complaintManager',
      title: '投诉管理',
      toolTip: '查看和处理用户投诉',
      value: false,
      disabled: false,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    {
        required: false,
        key: 'operationLogs',
        title: '查看操作日志',
        toolTip: '查看操作轨迹',
        value: false,
        disabled: false,
        special: false,
        dataType: DATA_TYPE.switch,
    },
  ],

  // 助教服务
  tutorSwitch: () => [
    {
      required: false,
      key: 'tutor',
      title: '助教服务',
      toolTip: '拥有助教服务权限',
      value: false,
      disabled: false,
      special: true,
      dataType: DATA_TYPE.switch,
    },
  ],

  // 收费标准
  tutorTypeInfo: () => [
    {
      required: false,
      key: 'type',
      title: '收费标准',
      toastTip: '请选择助教收费标准',
      disabled: true,
      value: 0,
      options: [],
      dataType: DATA_TYPE.select,
    },
  ],

  // 助教服务
  tutorInfo: () => [
    {
      required: false,
      key: 'duration',
      title: '课程时间',
      toastTip: '填写的课程时间须大于0',
      type: 'number',
      value: '',
      suffix: '分钟',
      disabled: true,
      dataType: DATA_TYPE.time,
    },
    {
      required: false,
      key: 'timeout',
      title: '超时',
      toastTip: '超时时间不能大于课程时间',
      type: 'number',
      value: '',
      suffix: '分钟增加1课程',
      disabled: true,
      dataType: DATA_TYPE.time,
    },
    {
      required: false,
      key: 'amount',
      title: '收费',
      toastTip: '填写的助教收费须大于0',
      type: 'number',
      value: '',
      suffix: '元/小时',
      disabled: true,
      dataType: DATA_TYPE.amount,
    },
    {
      required: false,
      key: 'minCharge',
      title: '最低消费',
      toastTip: '请输入助教最低消费',
      type: 'number',
      value: '',
      suffix: '小时',
      disabled: true,
      dataType: DATA_TYPE.ext,
    },
    {
      required: false,
      key: 'commission',
      title: '助教提成',
      toastTip: '请输入助教提成',
      type: 'number',
      value: '',
      // suffix: '元/小时',
      suffix: '',
      disabled: true,
      dataType: DATA_TYPE.amount,
      options: [
        {
          label: '元/小时',
          key: 1,
        },
        {
          label: '%',
          key: 2,
        },
      ],
    },
  ],

  // 记分服务
  scoreSwitch: () => [
    {
      required: false,
      key: 'scorer',
      title: '记分服务',
      toolTip: '拥有记分服务权限',
      value: false,
      disabled: false,
      special: true,
      dataType: DATA_TYPE.switch,
    },
  ],

  // 记分服务子项
  scoreInfo: () => [
    {
      required: false,
      key: 'amount',
      title: '收费',
      toastTip: '填写的记分收费须大于0',
      type: 'number',
      value: '',
      suffix: '元/小时',
      disabled: true,
      dataType: DATA_TYPE.amount,
    },
    {
      required: false,
      key: 'minCharge',
      title: '最低消费',
      toastTip: '请输入记分最低消费',
      type: 'number',
      value: '',
      suffix: '小时',
      disabled: true,
      dataType: DATA_TYPE.ext,
    },
    {
      required: false,
      key: 'commission',
      title: '记分提成',
      toastTip: '请输入记分提成',
      type: 'number',
      value: '',
      suffix: '元/小时',
      disabled: true,
      dataType: DATA_TYPE.amount,
    },
  ],

  // 运营设置子项
  operationInfo: () => [
    {
      required: false,
      key: 'runSettings',
      title: '运营设置',
      toolTip: '拥有运营设置权限',
      value: false,
      disabled: false,
      special: true,
      dataType: DATA_TYPE.switch,
    },
    {
      required: false,
      key: 'settingsTablePrice',
      title: '设置球台价格',
      toolTip: '拥有设置球台价格权限',
      value: false,
      disabled: true,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    {
      required: false,
      key: 'settingsMeal',
      title: '设置套餐',
      toolTip: '拥有设置套餐权限',
      value: false,
      disabled: true,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    // {
    //   required: false,
    //   key: 'settingsDiscount',
    //   title: '设置折扣',
    //   toolTip: '拥有设置折扣权限',
    //   value: false,
    //   disabled: true,
    //   special: false,
    //   dataType: DATA_TYPE.switch,
    // },
    // {
    //   required: false,
    //   key: 'settingsWallets',
    //   title: '设置钱包',
    //   toolTip: '拥有设置钱包权限',
    //   value: false,
    //   disabled: true,
    //   special: false,
    //   dataType: DATA_TYPE.switch,
    // },
    {
      required: false,
      key: 'cashierManagement',
      title: '设置前台操作权限',
      toolTip: '管理前台权限',
      value: false,
      disabled: true,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    {
      required: false,
      key: 'settingsTableBinding',
      title: '设置球台绑定',
      toolTip: '拥有设置球台绑定权限',
      value: false,
      disabled: true,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    {
      required: false,
      key: 'settingsTicketPrint',
      title: '设置小票打印',
      toolTip: '拥有设置小票打印权限',
      value: false,
      disabled: true,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    // {
    //   required: false,
    //   key: 'settingsRechargeGift',
    //   title: '设置充值赠送',
    //   toolTip: '拥有设置充值赠送权限',
    //   value: false,
    //   disabled: true,
    //   special: false,
    //   dataType: DATA_TYPE.switch,
    // },
    {
      required: false,
      key: 'settingsCoupon',
      title: '设置卡券',
      toolTip: '拥有设置卡券权限',
      value: false,
      disabled: true,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    {
      required: false,
      key: 'settingsPoster',
      title: '设置海报',
      toolTip: '拥有设置海报权限',
      value: false,
      disabled: true,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    {
      required: false,
      key: 'grouponSetting',
      title: '设置团购',
      toolTip: '拥有设置团购权限',
      value: false,
      disabled: true,
      special: false,
      dataType: DATA_TYPE.switch,
    }
  ],

  // 数据查看子项
  lookDataInfo: () => [
    {
      required: false,
      key: 'datasView',
      title: '数据查看',
      toolTip: '',
      value: false,
      disabled: false,
      special: true,
      dataType: DATA_TYPE.switch,
    },
    {
      required: false,
      key: 'realtimeRevenue',
      title: '查看实时营收',
      toolTip: '拥有查看实时营收权限',
      value: false,
      disabled: true,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    {
      required: false,
      key: 'overtimeReport',
      title: '查看交班报表',
      toolTip: '拥有查看交班报表权限',
      value: false,
      disabled: true,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    {
      required: false,
      key: 'revenueSettlement',
      title: '查看营收结算',
      toolTip: '拥有查看营收结算权限',
      value: false,
      disabled: true,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    {
      required: false,
      key: 'dataStatistics',
      title: '查看数据统计',
      toolTip: '拥有查看数据统计权限',
      value: false,
      disabled: true,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    {
      required: false,
      key: 'serviceRecords',
      title: '查看服务记录',
      toolTip: '拥有查看服务记录权限',
      value: false,
      disabled: true,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    {
      required: false,
      key: 'profitCalculation',
      title: '查看利润计算器',
      toolTip: '拥有查看利润计算器权限',
      value: false,
      disabled: true,
      special: false,
      dataType: DATA_TYPE.switch,
    },
    {
      required: false,
      key: 'unionPay',
      title: '查看银联提现/记录',
      toolTip: '拥有银联提现对账权限',
      value: false,
      disabled: true,
      special: false,
      dataType: DATA_TYPE.switch,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/containers/ClubEmployeeManager/component/property.js